import { plaintextWarning, type PlaintextExposure } from '../../core/popularImages'

/**
 * The unencrypted-port warning on the screens that sign: the tenant already
 * acknowledged it on Configure, or is sent back there to do so.
 */
export function PlaintextNotice({ exposure, acknowledged }: { exposure: PlaintextExposure; acknowledged: boolean }) {
  const warning = plaintextWarning(exposure)
  return <div className="notice notice-caution" role={acknowledged ? undefined : 'alert'}>
    <strong>{warning.title}</strong>
    <p>{warning.text}</p>
    <p>{acknowledged ? 'You confirmed this on Configure.' : 'Confirm this on Configure before you continue.'}</p>
  </div>
}
